import React, { useState } from 'react';
import ekybService from '../../services/ekybService';
import '../../styles/ekyb.css';

const StepSearch = ({ jurisdiction, onSearchComplete }) => {
  const [companyId, setCompanyId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const jurisdictionLabels = {
    finland: 'Finnish Business ID',
    sweden: 'Swedish Organization Number',
    denmark: 'Danish CVR Number'
  };

  const handleSearch = async () => {
    setError('');

    // Validate format
    const validation = ekybService.validateCompanyId(jurisdiction, companyId);
    if (!validation.valid) {
      setError(validation.message);
      return;
    }

    setLoading(true);

    try {
      const result = await ekybService.searchCompany(jurisdiction, companyId);
      onSearchComplete(result);
    } catch (err) {
      setError(err.message || 'Company search failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSearch();
    }
  };

  const exampleId = ekybService.getExampleId(jurisdiction);

  return (
    <div className="ekyb-step-container">
      <div className="ekyb-step-header">
        <h2 className="ekyb-step-title">Entity Identification</h2>
        <p className="ekyb-step-subtitle">
          Enter the company registration number to retrieve entity information from the business register.
        </p>
      </div>

      <div className="ekyb-form-group">
        <label className="ekyb-label">
          {jurisdictionLabels[jurisdiction] || 'Company ID'}
        </label>
        <input
          type="text"
          className={`ekyb-input ${error ? 'error' : ''}`}
          placeholder={exampleId}
          value={companyId}
          onChange={(e) => setCompanyId(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
        {error && <span className="ekyb-error-message">{error}</span>}
        {!error && <span className="ekyb-hint">Example: {exampleId}</span>}
      </div>

      <div className="ekyb-button-group">
        <button
          className="ekyb-button ekyb-button-primary"
          onClick={handleSearch}
          disabled={loading || !companyId.trim()}
        >
          {loading ? 'Searching...' : 'Search Registry'}
        </button>
      </div>
    </div>
  );
};

export default StepSearch;
